export const CORPORATE_INVENTORY_CUSTOMIZED_REPORT_NAME =
  'CORPORATE_INVENTORY_TABLE'

export const CORPORATE_PURCHASE_CUSTOMIZED_REPORT_NAME =
  'BK_CORPORATE_PURCHASE_TABLE'

export const CORPORATE_PURCHASE_WITH_VENDOR_CUSTOMIZED_REPORT_NAME =
  'BK_CORPORATE_PURCHASE_TABLE_WITH_VENDOR'
